module.exports = __webpack_public_path__ + "static/fujiwara-609b08a51bdc833709980f9b84df15b1.png";